class App
{
  // ---------------------------------------------------------------------------------------------------------
	// --	App
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    // console.log('technology.js')

    //インデックスからのリンク
    const holder = this
    $('.index ul li a').each(function(index){
      $(this).click(function(e){
        e.preventDefault()

        //ページ表示
        holder.update(index)

        //スクロール
        const headerH = $("header").outerHeight()
        const target = $('.pages .page').eq(index)
        const position = target.offset().top - (headerH + 20);
        $('body,html').stop().animate({scrollTop:position}, 500);
      })
    })

    //つづきボタン
    this.nextBtn = $('.next-page')
    this.nextBtn.click((e)=>{
      e.preventDefault()
      this.update(this.pageIndex + 1)
    })

    //アップデート
    this.pageIndex = -1
    this.update(-1)
  }


  // ---------------------------------------------------------------------------------------------------------

  /**
   * アップデート
   */
  update(newIndex)
  {
    if(newIndex < this.pageIndex) return

    //インデックス更新
    this.pageIndex = newIndex

    //ブロックの表示更新
    const holder = this
    $('.pages .page').each(function(index){
      if(index <= holder.pageIndex)
      {
        //GA
        if($(this).css('display') == 'none')
        {
          var page = document.location.pathname
          if (page.indexOf('index.html') > -1)
          {
            page = page.split('index.html')[0]
          }
          page += 'page0' + (index + 1) + '.html'
          // console.log('page:' + page)
          ga('send', 'pageview', page)
        }

        //表示
        $(this).show()
      }
    })

    //ページ数
    const pageNum = $('.pages .page').length

    //次へボタン更新
    if(this.pageIndex >= pageNum - 1)
    {
      this.nextBtn.hide()
    }
    else
    {
      //タイトル変更
      const currentPage = $('.pages .page').eq(this.pageIndex + 1)
      this.nextBtn.find('.title').text(currentPage.find('h5 >span').text())

      //ボタン表示
      this.nextBtn.show()
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

// var app;
$(function(){
  new App();
});
